export function isReadableAsInt(value) {
    return Number.isInteger(Number(value));
}